'use strict';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/skip';
import {applyAutoFilter, ReduxList} from '../../_libs/redux-observable-list';
import {getCollection} from '../../core-utilities/domain/ReduxUtils';
import {naturalCompare} from '../../core-utilities/filters/filterUtils';
import {SortMethod} from '../../core-utilities/filters/SortMethod';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {buildParentChannelSyncNotifier} from '../../auth/utils/redux-lists';
import {ORGANIZATION_COLLECTION} from '../../organizations/domain/config';
import {PERSONNEL_COLLECTION} from '../domain/PersonDomain';
import {TEAMS_COLLECTION} from '../domain/TeamDomain';
import {buildListSupportEpics} from '../epics/listSupportEpics';
import {logger} from './logger';


export const defaultSortOptions = {
  currentMethod: SortMethod.ASCENDING.name,
  property: 'name',
};

export const SUB_HEADER = 'SUB_HEADER';
export const TEAMS = 'TEAMS';
export const PERSONNEL = 'PERSONNEL';

export function groupByType(list) {
  let currentLabel;
  let id = 0;
  const result = [];
  list.forEach(model => {
    const collection = getCollection(model);

    let displayLabel;
    if (collection === TEAMS_COLLECTION) {
      if (model.type && model.type.namePlural) {
        displayLabel = model.type.namePlural;
      } else {
        displayLabel = TEAMS;
      }
    } else if (collection === PERSONNEL_COLLECTION) {
      displayLabel = PERSONNEL;
    }

    if (currentLabel !== displayLabel) {
      currentLabel = displayLabel;

      if (currentLabel === PERSONNEL) {
        result.push(makeSubHeader(PERSONNEL, id++));
      } else {
        result.push(makeSubHeader(currentLabel, id++));
      }
    }
    result.push(model);
  });
  return result;
}

// exposed for testing
export function makeSubHeader(name, id) {
  return {
    type: SUB_HEADER,
    id: `SUB_HEADER${id}`,
    name: name,
  };
}

export const REDUX_OPTIONS = {
  applySortOptions,
  listTransform: groupByType,
};

export function buildPeopleList(options) {
  const matchesAutoFilter = applyAutoFilter(['name'], 1);

  const reduxList = new ReduxList({
    ...BASE_REDUX_LIST_OPTIONS,
    pageSize: 100,
    hasParentId: true,
    useDelete: true,
    useFiltering: true,
    useAutoFilter: true,
    useFilterOptions: false,
    useSortOptions: false,
    defaultSortOptions,
    isVisible: isItemVisible,
    applySortOptions,
    syncNotifier: buildParentChannelSyncNotifier(ORGANIZATION_COLLECTION, 'people', `people syncNotifier`),
    logger,
    ...options,
  });

  const supportEpics = buildListSupportEpics({
    actions: reduxList.actions,
    getState: options.getState,
    logger,
  });

  reduxList.epics.addEpics(supportEpics);

  return reduxList;

  function isItemVisible(item, filterData) {
    if (!isObject(item)) return false;
    if (!matchesAutoFilter(item, filterData.filter)) return false;
    if (item.isDeleting) return false;
    return true;
  }
}

// TODO: this requires a more complex comparator
/**
 * first, sort teams then personnel
 * next, if team, sort by team type name
 *
 *
 * @param list
 * @param sortOptions
 * @return {*}
 */
export function applySortOptions(list, sortOptions) {
  return list.sort(peopleComparator);
}

function peopleComparator(p1, p2) {
  const c1 = getCollection(p1);
  const c2 = getCollection(p2);

  // sort teams before people. sort null stuff to the end as a safeguard
  if (c1 !== c2 || !c1 || !c2) {
    return peopleCollectionComparator(c1, c2, SortMethod.ASCENDING);
  } else if (c1 === TEAMS_COLLECTION) {
    // sort by team type, then by name
    const teamType = naturalCompare(
      get(p1, 'type.namePlural', null),
      get(p2, 'type.namePlural', null),
      SortMethod.ASCENDING.val,
      true,
    );
    return teamType !== 0 ? teamType : naturalCompare(p1.name, p2.name, SortMethod.ASCENDING.val, true);

  } else {
    return naturalCompare(p1.name, p2.name, SortMethod.ASCENDING.val, true);
  }
}

function peopleCollectionComparator(c1, c2, currentMethod) {
  const x1 = c1 === TEAMS_COLLECTION ? 0 : 1;
  const x2 = c2 === TEAMS_COLLECTION ? 0 : 1;

  if (x1 === x2) {
    return 0;
  } else if (x1 < x2) {
    return currentMethod.val ? -1 : 1;
  } else {
    return currentMethod.val ? 1 : 0;
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/redux/peopleConfig.js